// The stock state rule, and nothing else.
//
// This lived in components/MaterialTable.tsx until slice 2.0b-iii, which
// needed it in services/pricing.ts for the SummaryStrip counter. A service
// importing a component module to borrow one predicate is the wrong
// direction, and the alternative -- a second inlined copy of the rule in
// pricing.ts -- is exactly the drift stockStateOf exists to prevent. So the
// rule moved down here, where both a service and a component can reach it.
//
// Deliberately a file of its own with NO runtime imports. withStockLevels and
// singleWarehouseName, the other stock-shaped functions, still live in
// services/api.ts next to the getStock call they post-process; they are not
// here because moving them is a larger change than this slice asked for.
// Keeping this module dependency-free is what makes it safe for pricing.ts
// (which imports types only) to depend on.

/** Which of the three stock states a level is in.
 *
 *  ONE definition, imported by every site that renders or filters on stock,
 *  so the picker, the quote grid and the summary counter cannot drift into
 *  disagreeing about what a missing level means. `null`/`undefined` is
 *  UNKNOWN -- never "out" -- and a stated 0 is "out".
 *
 *  ⚠️ `!= null` RATHER THAN A TRUTHY TEST, deliberately, and for the same
 *  reason unpricedGuard's hasPrice does it: `stock && stock > 0` reads a
 *  stated 0 as an absence, which is the collapse this function exists to
 *  prevent. */
export type StockState = "unknown" | "out" | "in";

export function stockStateOf(level: number | undefined | null): StockState {
  if (level == null) return "unknown";
  return level > 0 ? "in" : "out";
}
